export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/google.ab25a61.svg";